module.exports = __webpack_public_path__ + "static/Verne3-745e42ff38ae50182a32d7ee9f1e8864.webp";